import { CodeField } from './CodeField';
import { createFormikField } from './utils/createFormikField';

export const FormikCodeField = createFormikField(CodeField);
